import qs from 'qs'

export const getAppIdFromURL = () => {
  let appId = null
  const reg = new RegExp(/\/apps\/(\d+)\/.*/)
  const res = window.location.href.match(reg)
  appId = (res && res.length > 0 && res[1]) || null
  if (appId == null) {
    const query =
      !typeof document === 'undefined'
        ? qs.parse(document.location.search.replace('?', ''))
        : {}
    return query.appId
  }
  return appId
}

export const getQuery = () => {
  if (!document || !document.location) {
    return {}
  }
  return qs.parse(document.location.search.split('?')[1])
}
// List 转 url传参
export const getParam = (obj) => {
  if (!obj) return ''
  const arr = Object.keys(obj)
  let str = '?'
  arr.forEach((i) => {
    str += `${i}=${obj[i]}&`
  })
  str = str.substr(0, str.length - 1)

  return str
}
